import React from 'react'
import { connect } from 'react-redux'
import ProgressBar from 'components/general/ProgressBar';
import { getScheduleDays, getScheduleData } from "data/Querys"
import { useParams } from "react-router-dom"
import { useQuery, QueryClient, dehydrate } from 'react-query'
import { useContext, useEffect } from 'react';
import { InitialDataContext } from 'InitialDataContext';
import Loader from 'components/general/Loader';
import { useTranslation, Trans } from "react-i18next";
import { useState } from "react";
import { findArray, filterArray } from 'helpers/utils';
import { Label } from './About';



export async function getSSRProps() {
    const queryClient = new QueryClient()
    await queryClient.prefetchQuery(['scheduleDays', 'ATH'], getScheduleDays);

    //console.log("prefetchQuery:" + JSON.stringify(dehydrate(queryClient)));
    return (
        dehydrate(queryClient)
    )
}




export async function getSSRData() {

    const queryClient = new QueryClient()
    // Ejecucion iterate 
    const daysData = await queryClient.fetchQuery(
        {
            queryKey: ['scheduleDays', 'ATH'],
            queryFn: getScheduleDays,

        });

    //comprobamos que tiene datos sino devolvemos un array vacio
    await Promise.all(daysData?.competition_schedule?.map(async (item, index) => {
        //daysData?.competition_schedule?.map(async (item, index) => {
        await queryClient.prefetchQuery(
            {
                queryKey: ['scheduleData', 'ATH', item.date, null],
                queryFn: getScheduleData,
            });


        console.log("Date:" + item.date)
    })
    )

    return dehydrate(queryClient)
}



function Home({ posts, numclicks, localtime }) {
    const [dataHy, setDataHy] = useState([{ data: 'koko' }]);
    const steps = [
        { code: 0, value: "Start", active: true },
        { code: 1, value: "12Km.", active: true },
        { code: 2, value: "27Km." },
        { code: 3, value: "Finish" }
    ];

    //Initialize Translations
    //const { t } = useTranslation('translations', 'common');
    useEffect(() => {

        // es asincrono 
        //  getSSRProps().then((data) => setDataHy(data));
        // console.log("prefetchQuery:" + JSON.stringify(getSSRProps));
        // console.log("prefetchQuery Data:" + JSON.stringify(dataHy));
    }, []);

    //Data from URL  
    const { mirs_discipline, mirs_event, mirs_date } = useParams()
    //Test Data SSR 
    const context = useContext(InitialDataContext);
    if (context._isServerSide) {
        console.log("Is server side:")
        context._key = ['scheduleDays', 'ATH']
        context._function = getScheduleDays;

        let loadFunc = async () => {
            console.log("EXECUTE QUERY NEW ")
            const queryClient = new QueryClient()

            await queryClient.prefetchQuery(
                {
                    queryKey: ['scheduleDays', 'ATH'],
                    queryFn: getScheduleDays,
                })

            return dehydrate(queryClient)

        }


        let loadFunc2 = async () => {
            const queryClient = new QueryClient()
            // Ejecucion iterate 
            const daysData = await queryClient.fetchQuery(
                {
                    queryKey: ['scheduleDays', 'ATH'],
                    queryFn: getScheduleDays,

                });

            //comprobamos que tiene datos sino devolvemos un array vacio
            await Promise.all(daysData?.competition_schedule?.map(async (item, index) => {
                //daysData?.competition_schedule?.map(async (item, index) => {
                await queryClient.prefetchQuery(
                    {
                        queryKey: ['scheduleData', 'ATH', item.date, null],
                        queryFn: getScheduleData,
                    });


                console.log("Date:" + item.date)
            })
            )

            context._data = dehydrate(queryClient)

        }
        context._data = getSSRProps();
        context._requests.push(getSSRProps());
        // console.log("NUM ELEMENTS: " + context._requests.length)

    } else {
        console.log("NO  server side:")
    }


    const { isError: isErrorScheduleDays, isLoading: isLoadingScheduleDays, data: daysData } = useQuery(
        {
            queryKey: ['scheduleDays', "ATH"],
            queryFn: getScheduleDays,
            refetchInterval: 30000,
            refetchIntervalInBackground: true,
            cacheTime: 300000,
            staleTime: 20000,
            suspense: false,
            notifyOnChangeProps: ['data', 'error']
        });




    const isLoading = isLoadingScheduleDays && !context._isServerSide
    //const isError = isErrorScheduleDays && !context._isServerSide

    if (isLoading) {
        return <Loader />
    }






    let dataLocal = {
        "competition_schedule": [
            { "discipline": { "code": "ATH", "description": "Athletics", "Koko": { "code": "MNZ" } }, "date": "2021-07-30", "eventCount": 37 },
            { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-07-30", "eventCount": 42 },
            { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-01", "eventCount": 29 }, { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-02", "eventCount": 28 }, { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-03", "eventCount": 38 }, { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-04", "eventCount": 37 }, { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-05", "eventCount": 33 }, { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-06", "eventCount": 9 }, { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-07", "eventCount": 7 }, { "discipline": { "code": "ATH", "description": "Athletics" }, "date": "2021-08-08", "eventCount": 1 }]
    }

    let filter = dataLocal && dataLocal?.competition_schedule?.filter(data => data.discipline.code === "ATH" && data.date === "2021-07-30");

    const filter1 = dataLocal?.competition_schedule?.filter(filtro);
    function filtro(data) {
        return (
            data.discipline.code1 === "ATH" &&
            data.date === "2021-07-30"
        );
    }



    const filtersData = {
        // date: ['2021-07-30'],
        "[discipline.code]": ["ATH"]
        //eventCount: [37],
        // discipline:{koko:{code:["MNZ"]}}
    };

    let filter2 = filterArray(dataLocal?.competition_schedule, filtersData);





    return (
        <div>

            ${JSON.stringify(filter2)}


            <h1 className='heading'>Home -- <Label data="HeaderBirthDate" /></h1>

            <ul>
                {posts.map(post => (
                    <li key={post.id}>{post.title}</li>
                ))}
            </ul>

            <br />
            <div><strong>Progress bar prototype</strong></div>
            <ProgressBar steps={steps} />
            <br /><br /><br /><br />

            <Example />
        </div>
    );
}

// Reaad Redux properties no useSelector 
const mapStateToProps = state => {
    return {
        posts: state.otherProp.posts,
        localtime: state.appGlobal.localtime,
        numclicks: state.numberOfClicks,

    }
}



class Example extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            active: 0
        };

    }

    render() {
        const divs = ["Text 1", "Text 2", "Text 3"];
        const updateActiveDiv = (value) => {
            this.setState(() => {
                //this line will reset the value to 
                //null if same element is clicked twice
                if (value === this.state.active) {
                    //value = null;
                };

                return {
                    active: value
                }

            });

        };

        let divText = divs.map((div, i) => {
            let color = this.state.active === i ? 'red' : 'black';
            return <div key={i} style={{ color }} onClick={() => updateActiveDiv(i)}>{div}</div>;
        });

        return (
            <div>
                value of .env:{process.env.REACT_APP_SERVER_URL}

                {divText}
            </div>
        );
    }
}



export default connect(mapStateToProps)(Home)
